var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourSitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427320090"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 79",
    x: 13.4688,
    width: 8.74891,
    height: 8.88778,
    rx: 1.38872,
    fill: "url(#paint0_linear_169_2715)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 80",
    x: 13.4688,
    y: 26.8018,
    width: 8.74891,
    height: 8.88778,
    rx: 1.38872,
    fill: "url(#paint1_linear_169_2715)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 81",
    y: 13.332,
    width: 8.74891,
    height: 8.88778,
    rx: 1.38872,
    fill: "url(#paint2_linear_169_2715)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 82",
    x: 26.9414,
    y: 13.4707,
    width: 8.74891,
    height: 8.88778,
    rx: 1.38872,
    fill: "url(#paint3_linear_169_2715)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 74",
    x: 6.10938,
    y: 6.11035,
    width: 23.4693,
    height: 23.4693,
    rx: 1.38872,
    fill: "current",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_2715",
    x1: 17.8432,
    y1: 0,
    x2: 17.8432,
    y2: 8.88778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "current"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_2715",
    x1: 17.8432,
    y1: 26.8018,
    x2: 17.8432,
    y2: 35.6895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "current"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_169_2715",
    x1: 8.88778,
    y1: 17.7065,
    x2: 6.12741e-7,
    y2: 17.4982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.986706,
    stopColor: "current"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_169_2715",
    x1: 35.8292,
    y1: 17.8452,
    x2: 26.9414,
    y2: 17.6369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "current"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourSitter);
export default __webpack_public_path__ + "static/media/fourSitter.c9bb6b7526e7255984650cf0a7c589b4.svg";
export { ForwardRef as ReactComponent };